module.exports = __webpack_public_path__ + "static/media/cyroth_nano_circles.c9cd6c96.png";